export default __webpack_public_path__ + "static/glukometerOval-6397ca782992814b9852afbb5b2cce67.png";